<template>
	<b-modal id="perfis-usuario" centered body-class="modal-body-custom container px-3 mt-2 pt-3 pb-0" size="md" footer-class="pt-0"
		no-close-on-backdrop no-close-on-esc :visible="true" @hidden="$emit('close')">
		<template #modal-title >
			<DynamicIcon icon="gear" classString="container-modal-title-icon mr-2"/>
			<p class="">Associar perfil</p> 
		</template>

        <div>
            <ul>
				<li v-for="perfilUsuario in perfisUsuario" :key="perfilUsuario.id">
					<b-form-checkbox v-model="perfilUsuario.value" :disabled="isPefilDisabled(perfilUsuario)">
						{{ perfilUsuario.name }}
					</b-form-checkbox>				
				</li>
			</ul>
            
			<ModalAlert id="perfilUsuarios-success" @close="handleClose">
				<DynamicIcon icon="check" :classString="'alert-exclamation'"/>
				Suas alterações foram salvas.
			</ModalAlert>

        </div>
		<template #modal-footer>
			<b-button pill class="btn-base outline-primary-btn optum-bold" @click="$bvModal.hide('perfis-usuario')">Cancelar</b-button>
			<b-button pill class="btn-base primary-btn" @click="salvar">Salvar</b-button>
		</template>	
	</b-modal>
</template>

<script>
import UserResource from "@/resources/UserResource"
import DynamicIcon from "@/components/commons/dynamicIcon/DynamicIcon.vue";
import ModalAlert from "@/components/commons/ModalAlert.vue"
import { mapGetters } from "vuex"

// Perfil que o sistema automáticamente define para o usuário
let perfisAutomaticos = [
	//-2 // Beneficiario Uploader
]

let perfisNaoPermitidos = [
	-1, -5
]

export default {
    name: "ModalPerfisUsuario",
	components: {
		DynamicIcon,
		ModalAlert
	},
	props: { usuario: Object },
    data() {
		return {
			perfisUsuario: []
		}
	},
	computed: {
		...mapGetters("user", ["authorities"]),
		isConsultorRelacionamento () {
			if ( this.authorities ) {
				return this.authorities.includes("ROLE_CONSULTOR_RELACIONAMENTO")
			}   
			return false;
		}
	},
		methods : {
		load() {
			UserResource.listPerfis(this.usuario.id, {showLoader: true})
			.then((perfisUsuario) => {
				if(this.isConsultorRelacionamento) {
					perfisUsuario = perfisUsuario.filter(perfil => !perfisNaoPermitidos.includes(perfil.id))
				}

				this.perfisUsuario = perfisUsuario
			})
		},
		salvar() {
			let permissions = []

			for (let i = 0; i < this.perfisUsuario.length; i++) {
				if (this.perfisUsuario[i].value) {
					permissions.push(this.perfisUsuario[i].id)
				}
			}

			UserResource.savePerfis(this.usuario.id, permissions, {showLoader: true})
            .then(() => {
                this.$bvModal.show('perfilUsuarios-success')
            })
		},
		isPefilDisabled(perfilUsuario) {
			return perfisAutomaticos.includes(perfilUsuario.id)
		},
		handleClose() {
			this.$bvModal.hide('perfis-usuario')
		}
	},
	created() {
		this.load()
	}
}
</script>

<style>

.modal-body-custom { 
	justify-content: flex-start !important;
	align-items:flex-start !important;
}
</style>

<style>
</style>
